module.exports = __webpack_public_path__ + "img/logo-rmbg-sm.ebf691d4.png";